import React from 'react';
import Accident from '../assets/images/Accident.svg';

export default () => {
  return <img src={Accident} alt="" />;
};